import React, { useState } from "react";
import api from "../../../../services/api";
import { showBasicAlert } from "../../../../core/common/useAlert";

const TabModals = ({
  data,
  onNotesAdded,
}: {
  data: any;
  onNotesAdded: any;
}) => {
  const signature = localStorage.getItem("signature");
  const [noteData, setNoteData] = useState<{
    title: string | null;
    note: string;
    attachments: File[];
  }>({
    title: null,
    note: "",
    attachments: [],
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setNoteData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return; // Ensure files exist

    const newFiles = Array.from(e.target.files); // Convert FileList to an array
    setNoteData((prev) => ({
      ...prev,
      attachments: prev.attachments
        ? [...prev.attachments, ...newFiles] // Append new files to existing ones
        : newFiles, // If no existing files, set new files
    }));
  };

  const handleRemoveFile = (index: number) => {
    setNoteData((prev) => ({
      ...prev,
      attachments: prev.attachments.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!noteData.note) {
      showBasicAlert("Please fill in all required fields");
      return;
    }

    try {
      var response = await api.post("leadService/addLeadnote", {
        signature,
        title: noteData.title || null,
        note: noteData.note,
        attachments: noteData.attachments,
        lead_id: data.id,
        company_id: data.company_id,
        company_type: data.company_type,
      });

      showBasicAlert(
        response?.data?.message?.[0]?.message ||
          "Lead Note Added Successfully!",
      );

      setNoteData({
        title: null,
        note: "",
        attachments: [],
      });

      closeModal();

      if (onNotesAdded) {
        await onNotesAdded();
      }
    } catch (error: any) {
      showBasicAlert(
        error?.data?.message?.[0]?.message || "Failed to add note!",
      );
    }
  };

  const closeModal = () => {
    const modalElement = document.getElementById("add_notes");
    if (modalElement) {
      const modalBackdrop = document.querySelector(".modal-backdrop");
      if (modalBackdrop) {
        modalBackdrop.remove();
      }
      modalElement.classList.remove("show");
      modalElement.style.display = "none";
      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("padding-right");
    }
  };

  return (
    <>
      <div className="modal fade" id="add_notes" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header header-border">
              <h5 className="modal-title">Add New Note</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal">
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">
                    Title <span className="text-muted"> (Optional)</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="title"
                    value={noteData.title || ""}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Note <span className="text-danger"> *</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={4}
                    name="note"
                    value={noteData.note}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Attachments</label>
                  <div className="border border-dashed rounded p-3 text-center">
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Selected Images</label>
                  {noteData.attachments.length > 0 ? (
                    <div className="d-flex flex-wrap">
                      {noteData.attachments.map((file, index) => (
                        <div
                          key={index}
                          className="position-relative me-2 mb-2">
                          <img
                            src={URL.createObjectURL(file)}
                            alt="Selected"
                            className="img-thumbnail"
                            style={{ maxWidth: "100px", maxHeight: "100px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-sm btn-danger position-absolute top-0 end-0"
                            onClick={() => handleRemoveFile(index)}>
                            ×
                          </button>
                          <h6 className="mb-1">{file.name}</h6>
                          <p className="mb-0">
                            {(file.size / 1024 / 1024).toFixed(2)} MB
                          </p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p>No images selected.</p>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-light"
                  data-bs-dismiss="modal">
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleSubmit}>
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default TabModals;
